import { getEmptyObject, isDevelopment } from "core/utils";

import type { EmptyObject } from "../../types";

export const BASE_PATH = isDevelopment() ? "" : "/administration/v4";
const DETAIL = "detail" as const;
export const DETAIL_ID = "detailId" as const;

const MULTIPLE_DETAIL = "multipleDetail" as const;
export const MULTIPLE_ID_1 = "multipleId1" as const;
export const MULTIPLE_ID_2 = "multipleId2" as const;
export const MULTIPLE_ID_3 = "multipleId3" as const;

export const REDUX_EXAMPLE = "redux-example" as const;
export const ERROR_HANDLING_EXAMPLE = "error-handling-example" as const;
export const NOTIFICATIONS_EXAMPLE = "notifications-example" as const;

/**
 * string path for routing
 */
export type Path = string;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type GlobalRoute = Route<any>;

/**
 * Default route params type.
 * @template K Type of possible keys. Default value is string. Can be used to set exact string literals.
 * Params defined by this type cannot be optional when exact string literals are used. If you need optional keys, use {@link OptionalPathParams} instead.
 * If you need mixed mandatory and optional parameters, or different value type than string, then you must define params type as readonly object yourself.
 * @see OptionalPathParams
 */
export type PathParams<K extends string = string> = Readonly<Record<K, string>>;

export type DetailPath = Readonly<{
    [DETAIL_ID]: string;
}>;
export type MultiplePath = Readonly<{
    [MULTIPLE_ID_1]: string;
    [MULTIPLE_ID_2]: string;
    [MULTIPLE_ID_3]: string;
}>;

export type Route<P extends PathParams> = Readonly<{
    path: Path;
    fillPathParams: (params?: P) => Path;
    useParams: () => P;
}>;

export const fillDetailPathParams = ({ detailId }: DetailPath) => `/${DETAIL}/${detailId}`;
export const fillMultipleDetailPathParams = ({ multipleId1, multipleId2, multipleId3 }: MultiplePath) =>
    `/${MULTIPLE_DETAIL}/${multipleId1}/${multipleId2}/${multipleId3}`;

/**
 * Generate path description. Just add ":" before parameters names and use them in fillPathParamsFunc.
 * @param filPathParamsFunc - path for fill parameters could be used, just add ":" before route parameters names
 * @param params - parameters of the route.
 */
export const generatePath = <P extends PathParams>(filPathParamsFunc: (params: P) => Path, params: P): Path =>
    filPathParamsFunc(Object.entries(params).reduce((result, [key, param]) => Object.assign(result, { [key]: `:${param}` }), {} as P));

/**
 * Creates simple route without path params.
 * @param path Route path.
 */
export const createSimpleRoute = (path: Path): Route<EmptyObject> => ({
    path,
    fillPathParams: () => path,
    useParams: getEmptyObject,
});

export const FORM_ACTION = {
    CREATE: "create",
    EDIT: "edit",
    VIEW: "view",
    COPY: "copy",
    IMPORT: "import",
    MOVE: "move",
    DEALER_CHANGE: "dealer-change",
    FINISH_DEALER_CHANGE: "finish-dealer-change",
    BATCH_UPDATE_CSV: "batch-update-csv",
    BATCH_UPDATE: "batch-update",
    BATCH_ADD: "batch-add",
    HISTORY: "history",
    GENERATE: "generate",
};
